import config from '../resources/config.json';
import { PREMIUM_ORIGIN_PARAM } from '@educaplay/app-core/functions';

const ORIGIN_STORAGE_KEY = 'premiumOrigin';

const readStoredOrigin = () => {
    try {
        return window.sessionStorage.getItem(ORIGIN_STORAGE_KEY) || '';
    } catch (error) {
        return '';
    }
};

const storeOrigin = (origin) => {
    try {
        window.sessionStorage.setItem(ORIGIN_STORAGE_KEY, origin);
    } catch (error) {
        return;
    }
};

export const getEnvironment = () => {
    const datosGenerales = document.getElementById('datosGenerales');
    let environmentDatosGenerales = {
        nonPersonalizedAds: '0',
        files: '',
        resources: '',
        entorno: '',
        idUsuario: '',
        tokenID: '',
        super: '',
        anonymousToken: '',
        showConsent: ''
    };
    const keys = Object.keys(environmentDatosGenerales);
    for (let i=0;i<keys.length;i++) {
        if (datosGenerales) {
            let dato = datosGenerales.getAttribute('data-' + keys[i]);
            if (dato) {
                environmentDatosGenerales[keys[i]] = dato;
            }
        }
    }
    let entornoCookies = datosGenerales.getAttribute('data-entornoCookies');
    if (entornoCookies === null) {
        entornoCookies = environmentDatosGenerales.entorno;
    }
    const environment = {
        ...environmentDatosGenerales,
        entornoCookies: entornoCookies,
        lang: '',
        subdomain: '',
        license: {
            id: 0,
            licenses: 1,
            periodicity: config.defaultPeriodicity
        },
        budget: '',
        email: '',
        action: '',
        checkAuthPaymentMethod: '',
        knowMoreUrls: {},
        origin: '',
        checkoutToken: '',
        renewalToken: '',
        renewalCheck: false,
        renewalPaymentIntent: '',
        renewalMethod: ''
    };
    environment['lang'] = document.documentElement.getAttribute('lang');
    if (environment['lang'] == 'en') {
        environment['subdomain'] = 'www';
    } else {
        environment['subdomain'] = environment['lang'];
    }
    if (environment.resources.substring(0,8) != 'https://') {
        environment['resources'] = 'https://' + environment.subdomain + '.' + environment.entorno + environment.resources;
    }
    const params = new URLSearchParams(window.location.search)
    const licenseId = params.get('id');
    const licenseNum = params.get('licenses');
    const licensePeriodicity = params.get('periodicity');
    const budget = params.get('budget');
    const checkAuthPaymentMethod = params.get('check');
    const email = params.get('email');
    const showConsent = params.get('showConsent');
    const origin = params.get(PREMIUM_ORIGIN_PARAM);
    if (origin) {
        environment['origin'] = origin;
        storeOrigin(origin);
    } else {
        environment['origin'] = readStoredOrigin();
    }
    const mountNode = document.getElementById('facturacionReact');
    const action = mountNode.getAttribute('data-action');
    const knowMoreUrls = mountNode.getAttribute('data-knowMoreUrls');
    const checkoutToken = mountNode.getAttribute('data-checkoutToken');
    if (checkoutToken !== null) {
        environment['checkoutToken'] = checkoutToken;
    }
    const renewalToken = mountNode.getAttribute('data-renewalToken');
    if (renewalToken !== null) {
        environment['renewalToken'] = renewalToken;
    }
    environment['renewalCheck'] = (params.get('renewalCheck') !== null);
    environment['renewalPaymentIntent'] = params.get('payment_intent') ?? '';
    environment['renewalMethod'] = params.get('renewalMethod') ?? '';
    if (knowMoreUrls !== null) {
        try {
            environment['knowMoreUrls'] = JSON.parse(knowMoreUrls);
        } catch (error) {
            environment['knowMoreUrls'] = {};
        }
    }
    if (licenseId !== null) {
        Object.keys(config.plans).forEach( mLicenseId => {
            if (mLicenseId == licenseId) {
                environment['license']['id'] = parseInt(licenseId);
            }
        });
    }
    if (licenseNum !== null) {
        if ((licenseNum > 0)) {
            if (licenseNum <= config.maxLicenses) {
                environment['license']['licenses'] = parseInt(licenseNum);
            } else {
                environment['license']['licenses'] = config.maxLicenses;
            }
        } 
    }
    if (licensePeriodicity !== null) {
        Object.keys(config.periodicities).forEach( mPeriodicity => {
            if (mPeriodicity == licensePeriodicity) {
                environment['license']['periodicity'] = licensePeriodicity;
            }
        });
    }
    if (budget !== null) {
        environment['budget'] = budget;
    }
    if (showConsent == 'no') {
        environment['showConsent'] = 'no';
    }
    if (checkAuthPaymentMethod !== null) {
        environment['checkAuthPaymentMethod'] = checkAuthPaymentMethod;
    }
    if (email !== null) {
        environment['email'] = email;
    }
    if (action !== null) {
        environment['action'] = action;
    } else if (params.get('renewal') == 'closed') {
        environment['action'] = 'renewal_closed';
    }
    return environment;
}

export const environment = getEnvironment();    